<template>
  <section class="registrationPrompt__Inner">
    <h1 class="registrationPrompt__Title">{{ $store.getters.getStringTranslation('changeEmailAddress') }}</h1>
    <p class="registrationPrompt__Lead">{{ $store.getters.getStringTranslation('enterNewEmail') }}</p>

    <form @submit.prevent="update()">
      <p>
        <label class="formLabel" for="email">{{ $store.getters.getStringTranslation('email') }}</label>
        <input class="formInput" type="email" id="email" v-model="email" />
      </p>

      <p v-if="success.text !== ''" class="message--Success" v-html="success.text"></p>
      <p v-if="error.text !== ''" class="message--Important" v-html="error.text"></p>

      <div class="registrationPrompt__Submit">
        <p>
          <router-link :to="{ name: 'Login' }"
            >&lt; {{ $store.getters.getStringTranslation('backToLogin') }}</router-link
          >
        </p>
        <p>
          <button class="button--Registration" type="submit" :disabled="success.status === true">
            {{ $store.getters.getStringTranslation('updateEmail') }}
          </button>
        </p>
      </div>
    </form>
  </section>
</template>

<script>
import HTTP from '@/http-common.js'

export default {
  name: 'ResetUpdate',
  data() {
    return {
      email: '',
      error: {
        text: '',
      },
      success: {
        text: '',
        status: false,
      },
    }
  },
  methods: {
    update() {
      this.loading = true
      HTTP.post(`change_email/${this.$route.params.id}`, { email: this.email })
        .then(() => {
          this.loading = false
          this.error.text = ''
          this.success.text = 'All done. Your new e-mail is all set.'
          this.success.status = true
          setTimeout(() => {
            this.$router.push({ name: 'Login' })
          }, 3000)
        })
        .catch((e) => {
          this.loading = false
          this.success.text = ''
          if (e.response.status === 422) {
            this.error.text = 'Something went wrong. Please contact support via communications@world-psi.org.'
          }
        })
    },
  },
}
</script>
